import emptyFolder from './emptyFolder';
import {
    getFocusedFilterForTable,
    getViewFilterForTable,
    TableView,
    getInboxClassificationFilterForTable,
    isFolderPaused,
    listViewStore,
} from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import folderStore, { Folder } from 'owa-folders';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { action, select } from 'satcheljs/lib/legacy';
import { isDeletedItemsFolderFromAnyMailbox, isDumpsterFolderFromAnyMailbox } from 'owa-mail-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { asDate } from 'owa-datetime';

export interface EmptyTableViewState {
    folderToBeEmptied: Folder;
}

export default action('emptyTableView')(
    select({
        folderToBeEmptied: tableViewToBeEmptied =>
            folderStore.folderTable.get(tableViewToBeEmptied.tableQuery.folderId),
    })(function emptyTableView(
        tableViewToBeEmptied: TableView,
        isExplicitSoftDelete: boolean,
        actionSource: ActionSource,
        rowKeysToExclude: string[],
        state?: EmptyTableViewState
    ) {
        const { folderToBeEmptied } = state;
        const {
            selectAllModeTimeStamp,
            id,
            serverFolderId,
            totalRowsInView,
        } = tableViewToBeEmptied;

        // Use server folder id for empty table view if it's not deleteditems or junkemail or dumpster.
        // For deleteditems or junkemail or dumpster, they don't support delete all with a viewFilter specified.
        if (
            isDumpsterFolderFromAnyMailbox(folderToBeEmptied.FolderId.Id) ||
            isDeletedItemsFolderFromAnyMailbox(folderToBeEmptied.FolderId.Id) ||
            folderToBeEmptied.DistinguishedFolderId === 'junkemail'
        ) {
            emptyFolder(
                folderToBeEmptied,
                FocusedViewFilter.None,
                InboxClassificationFilter.None,
                'All',
                isExplicitSoftDelete,
                actionSource,
                rowKeysToExclude,
                selectAllModeTimeStamp,
                id
            );
        } else {
            // Copy properties from folderToBeEmptied to folder
            const folder: Folder = { ...folderToBeEmptied };
            folder.FolderId = {
                Id: serverFolderId,
            };
            folder.TotalCount = totalRowsInView;

            let clientLastSyncTime: Date = selectAllModeTimeStamp;

            if (isFolderPaused(folderToBeEmptied.FolderId.Id)) {
                const inboxPausedDate = asDate(listViewStore.inboxPausedDateTime);

                if (inboxPausedDate < selectAllModeTimeStamp) {
                    clientLastSyncTime = inboxPausedDate;
                }
            }

            emptyFolder(
                folder,
                getFocusedFilterForTable(tableViewToBeEmptied),
                getInboxClassificationFilterForTable(tableViewToBeEmptied.id),
                getViewFilterForTable(tableViewToBeEmptied),
                isExplicitSoftDelete,
                actionSource,
                rowKeysToExclude,
                clientLastSyncTime,
                id
            );
        }
    })
);
